import { GlobalState } from './index';

export const selectCurrentRoute = (state: GlobalState) => state?.router?.state?.url;
export const selectRouteParams = (state: GlobalState) => state?.router?.state?.params;
export const selectQueryParams = (state: GlobalState) => state?.router?.state?.queryParams;